export default "__VITE_ASSET__CE_$eWhn__"